import React, { useState } from "react";
import './FilterSidebar.css';

const FilterSidebar = ({ open, onClose, filters, setFilters, onApply, productCounts }) => {
  const [expandedSections, setExpandedSections] = useState({
    brand: true,
    productType: false,
    availability: false,
  });

  const toggleSection = (section) => {
    setExpandedSections((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };

  const handleCheckboxChange = (category, value) => {
    setFilters((prev) => ({
      ...prev,
      [category]: prev[category].includes(value)
        ? prev[category].filter((item) => item !== value)
        : [...prev[category], value],
    }));
  };

  const handleRemoveAll = () => {
    setFilters({
      brands: [],
      types: [],
      availability: [],
    });
  };

  return (
    <>
      {open && <div className="filter-overlay" onClick={onClose} />}
      <div className={`filter-drawer ${open ? "open" : ""}`}>
        <div className="filter-header">
          <h3>Filter</h3>
          <button className="close-btn" onClick={onClose}>✕</button>
        </div>
        <div className="filter-body">
          <div className="filter-group">
            <div className="filter-title" onClick={() => toggleSection("brand")}>
              <span>Brand</span>
              <span className="toggle-icon">{expandedSections.brand ? "−" : "+"}</span>
            </div>
            {expandedSections.brand && (
              <div className="filter-options">
                <label>
                  <input
                    type="checkbox"
                    checked={filters.brands.includes("BKIND")}
                    onChange={() => handleCheckboxChange("brands", "BKIND")}
                  />
                  <span>BKIND ({productCounts.brands.BKIND || 0})</span>
                </label>
                <label>
                  <input
                    type="checkbox"
                    checked={filters.brands.includes("MOKOSH")}
                    onChange={() => handleCheckboxChange("brands", "MOKOSH")}
                  />
                  <span>MOKOSH ({productCounts.brands.MOKOSH || 0})</span>
                </label>
              </div>
            )}
          </div>
          <div className="filter-group">
            <div className="filter-title" onClick={() => toggleSection("productType")}>
              <span>Product type</span>
              <span className="toggle-icon">{expandedSections.productType ? "−" : "+"}</span>
            </div>
            {expandedSections.productType && (
              <div className="filter-options">
                {["Balm", "Cream", "Face Care", "Gel", "Scrub", "Serum"].map(type => (
                  <label key={type}>
                    <input
                      type="checkbox"
                      checked={filters.types.includes(type)}
                      onChange={() => handleCheckboxChange("types", type)}
                    />
                    <span>{type} ({productCounts.types[type] || 0})</span>
                  </label>
                ))}
              </div>
            )}
          </div>
          <div className="filter-group">
            <div className="filter-title" onClick={() => toggleSection("availability")}>
              <span>Availability</span>
              <span className="toggle-icon">{expandedSections.availability ? "−" : "+"}</span>
            </div>
            {expandedSections.availability && (
              <div className="filter-options">
                <label>
                  <input
                    type="checkbox"
                    checked={filters.availability.includes("inStock")}
                    onChange={() => handleCheckboxChange("availability", "inStock")}
                  />
                  <span>In stock ({productCounts.availability.inStock || 0})</span>
                </label>
                <label>
                  <input
                    type="checkbox"
                    checked={filters.availability.includes("outOfStock")}
                    onChange={() => handleCheckboxChange("availability", "outOfStock")}
                  />
                  <span>Out of stock ({productCounts.availability.outOfStock || 0})</span>
                </label>
              </div>
            )}
          </div>
        </div>
        <div className="filter-footer">
          <button className="apply-btn" onClick={onApply}>APPLY</button>
          <button className="clear-btn" onClick={handleRemoveAll}>REMOVE ALL</button>
        </div>
      </div>
    </>
  );
};

export default FilterSidebar;